import React from 'react';

export default function StudentCohortDetails(props) {
  return (
    <div className="abl-inspector-group abl-student-cohort-details">
      <div className="abl-student-capacity">{props.capacity}</div>
      
      <div className="abl-cohort-demagraphics">
        <label>Gender</label>
        <div className="abl-label-content">
          F (14)
        </div>
        <div className="abl-label-content">
          M (10)
        </div>
      </div>
      <div className="abl-cohort-demagraphics">
        <label>Grades</label>
        <div className="abl-label-content">
          9th (10)
        </div>
        <div className="abl-label-content">
          10th (4)
        </div>
      </div>
    </div>
  );
};


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule_inspector/student_cohort_details.js
 **/